import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { atualizarAgora } from './useContextoChatwoot'
import './frescor.css'

/**
 * A hora do dado que está na tela, e o botão de refazer a busca (demanda 109).
 *
 * 🔴 **A marca de frescor é o que transforma "dado velho com cara de certo" em
 * "dado das 10:14, e agora são 11:40".** Sem ela, o painel parece igualmente
 * confiável tendo buscado há dez segundos ou há duas horas — e é justamente por
 * parecer certo que ninguém confere.
 *
 * ⭐ **O botão é complemento, não solução.** Ele resolve para quem desconfia; o
 * defeito perigoso é o de quem **não** desconfia. Por isso a atualização
 * automática (contexto ao voltar à aba + vigília) veio junto, e não depois.
 */
export function BarraDeAtualizacao({ em }: { em: Date | null }) {
  const { t } = useTranslation()

  // Redesenha de minuto em minuto para o "há X minutos" não congelar. Sem isto
  // a própria marca de frescor ficaria velha — que seria a piada pronta.
  const [, redesenhar] = useState(0)

  useEffect(() => {
    const relogio = setInterval(() => redesenhar((n) => n + 1), 60_000)
    return () => clearInterval(relogio)
  }, [])

  return (
    <div className="frescor">
      <span className="frescor__hora">
        {em ? t('frescor.em', { hora: hora(em), idade: idade(em, t) }) : t('frescor.buscando')}
      </span>

      <button type="button" className="frescor__botao" onClick={atualizarAgora}>
        {t('frescor.atualizar')}
      </button>
    </div>
  )
}

function hora(em: Date) {
  return em.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
}

function idade(em: Date, t: (chave: string, opcoes?: Record<string, unknown>) => string) {
  const minutos = Math.floor((Date.now() - em.getTime()) / 60_000)

  if (minutos < 1) return t('frescor.agora')
  return t('frescor.minutos', { count: minutos })
}
